import { createReducerUsingActionHandlers } from '@travel-frontend/state-handling-sdk';
import { AIRPORTS_FIELD_FUNCTION_VALUE_CHANGED, AIRPORTS_FIELD_VALUE_CHANGED, DESTINATION_FIELD_FUNCTION_VALUE_CHANGED, DESTINATION_FIELD_RESET_CLICKED, DESTINATION_FIELD_VALUE_CHANGED, TRAVEL_PERIOD_FIELD_FUNCTION_VALUE_CHANGED, TRAVEL_PERIOD_FIELD_VALUE_CHANGED, TRAVEL_TYPE_CHANGED, TRAVEL_TYPE_FUNCTION_CHANGED, TRAVELLERS_FIELD_FUNCTION_VALUE_CHANGED, TRAVELLERS_FIELD_MULTIROOM_FUNCTION_VALUE_CHANGED, TRAVELLERS_FIELD_MULTIROOM_VALUE_CHANGED, TRAVELLERS_FIELD_VALUE_CHANGED } from '../../../components/SearchForm/redux/actions.js';
import { searchFormState } from '../../../components/SearchForm/redux/SearchFormState.js';
const initialState = {
  travelType: null,
  values: {
    destination: null,
    airports: null,
    travellers: null,
    travellersMultiroom: null,
    travelPeriod: null
  }
};
// For debugging: import trackingEvents and wrap reducer
// const logTrackingEvents = (reducer) => (prevState, action) => {
//   const nextState = reducer(prevState, action);
//   if (typeof trackingEvents[action.type] === 'function') {
//     console.log(trackingEvents[action.type](action, prevState, nextState));
//   }
//   return nextState;
// };
const handleTravelTypeChange = (state, action) => ({
  ...state,
  travelType: action.payload.travelType
});
const handleDestinationValueChange = (state, action) => ({
  ...state,
  values: {
    ...state.values,
    destination: action.payload.value
  }
});
const handleDestinationReset = state => ({
  ...state,
  values: {
    ...state.values,
    destination: null
  }
});
const handleAirportsValueChange = (state, action) => ({
  ...state,
  values: {
    ...state.values,
    airports: action.payload.value
  }
});
const handleTravellersValueChange = (state, action) => ({
  ...state,
  values: {
    ...state.values,
    travellers: action.payload.value ? {
      adultCount: action.payload.value.adultCount,
      childrenAges: action.payload.value.childrenAges
    } : null
  }
});
const handleTravellersMultiroomValueChange = (state, action) => ({
  ...state,
  values: {
    ...state.values,
    travellersMultiroom: action.payload.value ? action.payload.value : null
  }
});
const handleTravelPeriodValueChange = (state, action) => ({
  ...state,
  values: {
    ...state.values,
    travelPeriod: action.payload.value ? {
      startDate: action.payload.value.startDate,
      endDate: action.payload.value.endDate,
      selectedState: action.payload.context?.selectedState || null,
      inputType: action.payload.context?.type || null,
      duration: action.payload.value.duration
    } : null
  }
});
const actionHandlers = {
  [TRAVEL_TYPE_CHANGED]: handleTravelTypeChange,
  [TRAVEL_TYPE_FUNCTION_CHANGED]: handleTravelTypeChange,
  [DESTINATION_FIELD_VALUE_CHANGED]: handleDestinationValueChange,
  [DESTINATION_FIELD_RESET_CLICKED]: handleDestinationReset,
  [DESTINATION_FIELD_FUNCTION_VALUE_CHANGED]: handleDestinationValueChange,
  [AIRPORTS_FIELD_VALUE_CHANGED]: handleAirportsValueChange,
  [AIRPORTS_FIELD_FUNCTION_VALUE_CHANGED]: handleAirportsValueChange,
  [TRAVELLERS_FIELD_VALUE_CHANGED]: handleTravellersValueChange,
  [TRAVELLERS_FIELD_FUNCTION_VALUE_CHANGED]: handleTravellersValueChange,
  [TRAVELLERS_FIELD_MULTIROOM_VALUE_CHANGED]: handleTravellersMultiroomValueChange,
  [TRAVELLERS_FIELD_MULTIROOM_FUNCTION_VALUE_CHANGED]: handleTravellersMultiroomValueChange,
  [TRAVEL_PERIOD_FIELD_VALUE_CHANGED]: handleTravelPeriodValueChange,
  [TRAVEL_PERIOD_FIELD_FUNCTION_VALUE_CHANGED]: handleTravelPeriodValueChange
};
export const searchFormReducer = createReducerUsingActionHandlers(initialState, actionHandlers);
export const getTravelType = state => searchFormState(state).travelType;
export const getValues = state => searchFormState(state).values;
export const getDestination = state => getValues(state).destination;
export const getAirports = state => getValues(state).airports;
export const getTravellers = state => getValues(state).travellers;
export const getTravellersMultiroom = state => getValues(state).travellersMultiroom;
export const getTravelPeriod = state => getValues(state).travelPeriod;